export default __webpack_public_path__ + "static/Concept5-b94b4d6a7c3a9fec29a75aaf975a8785.png";